import { render, staticRenderFns } from "./returndialog.vue?vue&type=template&id=40f2a27e&scoped=true"
import script from "./returndialog.vue?vue&type=script&lang=js"
export * from "./returndialog.vue?vue&type=script&lang=js"
import style0 from "./returndialog.vue?vue&type=style&index=0&id=40f2a27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f2a27e",
  null
  
)

export default component.exports